import "./index.scss";
function AboutUs() {
  return (
    <div className="about-container">
      <div className="subtitle">关于我们</div>
      <div className="title">ABOUT US</div>
      <div className="about-info">
        <div className="info-left">
          <img className="img" src={require("../../../../assets/about@3x.png")}></img>
        </div>
        <div className="info-right">
          <div className="right-title">
            <span>百昌科技集团重磅研发</span>
            <div className="line"></div>
          </div>
          <div className="right-info">
            <div>
              再查查由百昌科技集团研发，面向国有/央企、金融机构、上市公司等企业客户。
            </div>
            <div>
              再查查提供完善的网络安全保障体系，已通过“国家三级等保”认证，融合百昌科技集团特殊资产处置领域多年专业积累、提供财产线索查询服务，协助防范金融风险，助力国央企及金融机构实现业务处理效能的全面提升。
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AboutUs;
